import React from 'react';
import Logo from '../../../assets/icons/logo_krainet.svg';
import './logoDemo.scss'

const LogoDemo = () => {
    return (
        <div className='logoDemo'>
            <Logo/>
        </div>
    );
};

export default LogoDemo;